import { Outlet } from "react-router-dom";

function ShippingMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default ShippingMain;